import { render, staticRenderFns } from "./VolumeClaimTemplate.vue?vue&type=template&id=c4088a5c&scoped=true&"
import script from "./VolumeClaimTemplate.vue?vue&type=script&lang=js&"
export * from "./VolumeClaimTemplate.vue?vue&type=script&lang=js&"
import style0 from "./VolumeClaimTemplate.vue?vue&type=style&index=0&id=c4088a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4088a5c",
  null
  
)

export default component.exports